@if (currentView === SETTINGS_VIEW) {
  <div class="title">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.TITLE' | translate }}
  </div>
  <div class="subtitle">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.PROMPT' | translate }}
  </div>
}

<div class="settings">
  @if (!loadingAvailabilityForm) {
    <form [formGroup]="form" (ngSubmit)="setAvailability()">
      <div class="week">
        @for (day of daysOfWeek; track day; let i = $index; let first = $first) {
          <mat-card appearance="outlined" class="weekday" [style.margin-left.px]="first ? 0 : -1">
            <mat-card-title class="weekday-title">
              <mat-checkbox [checked]="isDayEnabled(day)" (change)="setIsDayEnabled(day, $event.checked)">
              </mat-checkbox>
              <div>
                {{ indexToDayOfWeekMapping[i].name }}
              </div>
            </mat-card-title>
            <mat-card-content class="weekday-content" (click)="openEditAvailabilityDialog(day)">
              @if (isDayEnabled(day)) {
                <div class="weekday-ranges">
                  @for (range of rangesForDay(day); track range) {
                    <a>
                      {{ range.start | date: 'h:mma' | lowercase }}–&#10; {{ range.end | date: 'h:mma' | lowercase }}
                    </a>
                  }
                </div>
              }
              @if (!isDayEnabled(day) || rangesForDay(day).length === 0) {
                <div class="unavailable">
                  {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.UNAVAILABLE' | translate }}
                </div>
              }
            </mat-card-content>
          </mat-card>
        }
      </div>
      @if (currentView === SETTINGS_VIEW) {
        <div class="timezone-selector">
          <glxy-timezone-selector
            [initialTimezone]="timezone"
            [control]="form.controls['timezone']"
          ></glxy-timezone-selector>
        </div>
      }
    </form>
  } @else {
    <div class="form-row fields-row day-container">
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
      <div class="shimmer-box stencil-shimmer"></div>
    </div>
    <div class="form-row fields-row shimmer-margin">
      <div class="shimmer-box stencil-shimmer time-zone-message"></div>
    </div>
    <div class="form-row form-actions shimmer-buttons">
      <button mat-raised-button color="primary" type="submit" [disabled]="true">
        {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
      </button>
    </div>
  }
  @if (shouldShowSlotSelectionErrorValue) {
    <glxy-error>
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.MANDATORY' | translate }}
    </glxy-error>
  }
  @if (shouldShowSlotAvailabilityErrorValue) {
    <glxy-error>
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.NO_AVAILABILITY' | translate }}
    </glxy-error>
  }
  @if (displayAvailabilityInsufficientDurationError) {
    <glxy-error>
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.MIN_DURATION' | translate: { duration: meetingDuration } }}
    </glxy-error>
  }
  @if (currentView === SETTINGS_VIEW && !isAvailabilitySet) {
    <glxy-error>
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.AVAILABILITY_TIME_REQUIRED_ERROR' | translate }}
    </glxy-error>
  }
</div>

@if (currentView === SETTINGS_VIEW) {
  <div class="actions">
    <div class="timezone-gutter"></div>
    <div class="form-row form-actions">
      @if (!savingAvailabilityForm) {
        <button
          mat-raised-button
          color="primary"
          type="submit"
          (click)="setAvailability()"
          [disabled]="currentView === SETTINGS_VIEW && !isAvailabilitySet"
        >
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
        </button>
      }
      @if (savingAvailabilityForm) {
        <span>
          <mat-spinner [diameter]="30" [strokeWidth]="8"></mat-spinner>
        </span>
      }
    </div>
  </div>
}
